export const DeliveryStatus = Object.freeze({
  CampaignBudgetPaused: 50,
  BudgetSuggestions: 1001,
});
